import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {testIdProps} from '@github-ui/test-id-props'
import type {ShowModelPayload} from '../../../types'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'

export function License() {
  const {modelLicense} = useRoutePayload<ShowModelPayload>()

  return <VerifiedHTMLDiv data-hpc className="tmp-p-3" html={modelLicense} {...testIdProps('license-content')} />
}
